import React, { useRef } from "react";

interface InputProps {
    input_name: string
    id?: string
    type?: string
    value?: string | number
    change_handler?: any
    placeholder?: string
    is_disable?: boolean
    other_classes?: string
    on_blur?: any
    onClickHandler?: any,
    min?: any,
    max?: any,
    accept?: any,
    reference?: any
}

const Input: React.FC<InputProps> = ({
    input_name,
    value,
    change_handler,
    type = "text",
    placeholder,
    is_disable = false,
    other_classes,
    id,
    on_blur,
    onClickHandler,
    min,
    max,
    accept,
    reference
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    return (
        <input
            name={input_name}
            type={type}
            onChange={(e)=>change_handler(e)}
            onBlur={on_blur}
            disabled={is_disable}
            className={`w-full h-12 px-3 border border-[#E6E6E6] rounded text-base text-[#1A1A1A] placeholder-[#999999] focus:outline-none focus:border-[#666666] ${other_classes}`}
            placeholder={placeholder}
            value={value}
            id={id}
            onClick={onClickHandler}
            {...(min !== undefined && { min })} // Conditionally add min
            {...(max !== undefined && { max })} // Conditionally add max
            {...(accept !== undefined && { accept })} // Conditionally add accept  
            ref={reference || inputRef}
        />
    );
};

export default Input;
